import type { App } from 'utils/app/types';
import type { Core } from 'chessboard/core/config/types';

/**
 * Returns a function that determines if an option is enabled
 */
export function isOptionEnabled(optionName: string) {
  return function optionValueIsTruthy(_event: App.Event, context: Core.Context): boolean {
    return Boolean(context.api?.getOptions?.()[optionName]);
  };
}
